import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../css/Form.css';

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showForgotPasswordPopup, setShowForgotPasswordPopup] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');
    setIsLoading(true);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/login`, formData);

      if (response.status === 200) {
        if (response.data.message === 'verify first') {
          const email = formData.email;

          try {
            const resendResponse = await axios.post(
              `${process.env.REACT_APP_API_URL}/api/auth/resendOtp?email=${encodeURIComponent(email)}`
            );

            if (resendResponse.status === 200) {
              setSuccessMessage('OTP resent! Redirecting to verification page...');
              setIsLoading(false);
              navigate('/otp-verification', { state: { email } });
            } else {
              setError('Failed to resend OTP. Please try again.');
              setIsLoading(false);
            }
          } catch (resendError) {
            console.error('Error resending OTP:', resendError);
            setError('Failed to resend OTP. Please try again.');
            setIsLoading(false);
          }
        } else {
          localStorage.setItem('token', response.data.token);
          setSuccessMessage('Login successful! Redirecting...');
          setTimeout(() => {
            setIsLoading(false);
            navigate('/update', { replace: true });
          }, 3000);
        }
      } else {
        setError('Login failed! Please check your credentials and try again.');
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Login error:', error);
      setError('Login failed! Please check your credentials and try again.');
      setIsLoading(false);
    }
  };

  const handleForgotPassword = async () => {
    setError('');
    setSuccessMessage('');
    setIsLoading(true);

    try {
      const email = formData.email;
      if (!email) {
        setError('Please enter your email before proceeding.');
        setIsLoading(false);
        return;
      }

      // Send OTP to the user's email
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/auth/resendOtp?email=${encodeURIComponent(email)}`
      );

      if (response.status === 200) {
        setSuccessMessage('OTP sent! Redirecting to reset password form...');
        setIsLoading(false);
        navigate('/reset-password', { state: { email } });
      } else {
        setError('Failed to send OTP. Please try again.');
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Forgot password error:', error);
      setError('Failed to send OTP. Please try again.');
      setIsLoading(false);
    }
  };

  return (
    <div className="form-container">
      <div className="form-wrapper">
        <h2>Login</h2>
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <input
              type="text"
              name="email"
              placeholder="Email"
              onChange={handleChange}
              value={formData.email}
              required
            />
          </div>
          <div className="input-group">
            <input
              type="password"
              name="password"
              placeholder="Password"
              onChange={handleChange}
              value={formData.password}
              required
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          {successMessage && <div className="success-message">{successMessage}</div>}
          <button type="submit" className="submit-btn" disabled={isLoading}>
            {isLoading ? 'Loading...' : 'Login'}
          </button>
        </form>
        {isLoading && (
          <div className="loading-indicator">
            <p>Processing your request, please wait...</p>
          </div>
        )}
        <p>
          Don't have an account? <a href="/register">Register here</a>
        </p>
        <p>
          Forgot your password?{' '}
          <button
            className="forgot-password-btn"
            onClick={() => setShowForgotPasswordPopup(true)}
          >
            Click here
          </button>
        </p>
        {showForgotPasswordPopup && (
          <div className="popup">
            <p>Do you want to send an OTP to your email?</p>
            <button onClick={handleForgotPassword}>Yes</button>
            <button onClick={() => setShowForgotPasswordPopup(false)}>No</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;
